<template>
  <a
    class="whatsapp-button"
    :href="`http://api.whatsapp.com/send?1=pt_BR&phone=${phone}`"
    target="_blank"
  >
    <img src="@/assets/images/logos/whatsapp.png" alt="whatsapp">
  </a>
</template>

<script>
export default {
  name: 'WhatsappButton',
  props: {
    phone: String
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.whatsapp-button
  @apply fixed flex items-center justify-center text-white text-3xl bg-green rounded-full shadow-lg cursor-pointer w-16 h-16
  bottom: 30px
  right: 30px
  img
    @apply w-8
</style>
